import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)
import { goHome } from '@/utils/topcrm'

const routes = [
  {
    path: '/',
    name: 'Index',
    component: () => import('@/views/newCreditReport/index.vue'),
  },
  {
    path: '/index/:id?',
    name: 'Index',
    component: () => import('@/views/newCreditReport/index.vue'),
  },
  {
    path: '/personalCenter/:from?',
    name: 'personalCenter',
    component: () => import('@/views/personalCenter/index.vue')
  },
  {
    path: '/pdf',
    name: 'pdf',
    meta: {
      external: true,
    },
    component: () => import('@/views/pdf/index.vue'),
  },
  {
    path: '/login',
    name: 'login',
    meta: {
      external: true,
    },
    component: () => import('@/views/login/index.vue'),
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: () => ({ y: 0 }),
  routes
})

const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

//白名单
const whiteList = ['/login'];

// 全局路由守卫
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem("TOKEN")
  if(token || whiteList.indexOf(to.path) !== -1){
    next();
  }else{
    let url = localStorage.getItem("VUE_APP_PRIMARY_PLATFORM_URL");
    if (!url) {
      next();
    }else{
      goHome();
    }
  }
})

export default router
